var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes loader-7-1{0%{transform:translateX(0)}to{transform:translateX(6px)}}@keyframes loader-7-2{0%{transform:translateX(0)}to{transform:translateX(-6px)}}")), /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0A30",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M6.853 10h5",
    style: {
      animation: "loader-7-1 1.5s cubic-bezier(.86,0,.07,1) infinite alternate both"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#265BFF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.147 14h5",
    style: {
      animation: "loader-7-2 1.5s cubic-bezier(.86,0,.07,1) infinite alternate both"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.6fe6a68ca0bf5d56517fc68a51a4b7cb.svg";
export { ForwardRef as ReactComponent };